import React from 'react';
export function Footer() {
  return <footer className="bg-brand-black text-gray-500 py-8 border-t border-white/10 text-center text-sm" data-id="element-114">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-115">
        <div data-id="element-116">
          &copy; {new Date().getFullYear()} ETA: Inclusive Succession. All
          rights reserved.
        </div>
        <div className="flex gap-6" data-id="element-117">
          <a href="#" className="hover:text-white transition-colors" data-id="element-118">
            Privacy Policy
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-119">
            Terms of Service
          </a>
          <a href="#" className="hover:text-white transition-colors" data-id="element-120">
            Contact
          </a>
        </div>
      </div>
    </footer>;
}